<template>
    <div>
        <nav-bar></nav-bar>
        <div class="container">
            <div class="section">
              <nav class="breadcrumb" aria-label="breadcrumbs">
                <ul>
                  <li class="is-active"><a href="#" aria-current="page">Chatbots</a></li>
                </ul>
              </nav>
                <div class="button is-primary is-left" @click="storeClient" :disabled="!isAdmin">
                    <span class="icon"><i class="fas fa-plus"></i></span>
                    <span class="is-capitalized">Nuevo Chatbot</span>
                </div>
                <br><br>
                <div class="container" style="overflow: scroll">
                <table class="table is-striped is-fullwidth">

                    <thead>
                    <tr>
                        <th class="is-capitalized">Nombre</th>
                        <th class="is-capitalized">Descripción</th>
                        <th class="table-button-column"></th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="(client, index) in clients" :key="client.idClient">
                        <td>{{client.name}}</td>
                        <td>{{client.description}}</td>
                        <td>
                          <div class="field has-addons">
                            <p class="control">
                              <a @click="showClient(client)"
                                 class="button is-primary"
                                 title="Ver chatbot">
                                <span class="icon"><i class="fas fa-eye"></i></span>
                              </a>
                            </p>
                            <p class="control">
                              <a @click="editClient(client)" :disabled="!isAdmin"
                                 class="button is-warning"
                                 title="Editar">
                                <span class="icon"><i class="fas fa-edit"></i></span>
                              </a>
                            </p>
                            <p class="control">
                              <a @click="deleteClient(index)" :disabled="!isAdmin"
                                 class="button is-danger"
                                 title="Eliminar">
                                <span class="icon"><i class="fas fa-trash-alt"></i></span>
                              </a>
                            </p>
                          </div>
                        </td>
                    </tr>
                    </tbody>

                </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import Auth from '../models/auth'

export default {
  data () {
    return {
      clients: []
    }
  },
  computed: {
    isAdmin () {
      return Auth.isAdmin()
    }
  },
  created () {
    this.api.post('/ClientGetList').then(response => {
      this.clients = response.clients
    })
  },
  methods: {
    storeClient () {
      if (!this.isAdmin) {
        return
      }
      this.$router.push('/clients/store')
    },
    showClient (client) {
      this.$router.push('/clients/' + client.idClient + '/intents')
    },
    editClient (client) {
      if (!this.isAdmin) {
        return
      }
      this.$router.push('/clients/' + client.idClient + '/update')
    },
    deleteClient (index) {
      if (!this.isAdmin) {
        return
      }
      let message = '¿Estás seguro de borrar el cliente ' + this.clients[index].name + '?'
      this.dialog.confirm({message}).then(() => {
        this.api.post('/ClientDelete', this.clients[index]).then(() => {
          this.api.post('/ClientGetList').then(response => {
            this.clients = response.clients
          })
        })
      }).catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Clients.vue